import { User } from '../../resources/user/domain/types/User';
import { PickDomain } from '../utilities/types/PickDomain';

export function showReferAFriend(
    user: PickDomain<
        User,
        'locale' | 'numberOfUserQuotesByStateCounters',
        {
            status: User['status'] | null;
        }
    >,
) {
    return (
        user.locale === 'fr-FR' &&
        (user.status === 'first timer experiencer' ||
            user.status === 'repeater experiencer' ||
            (user.status === 'wanderlust' && user.numberOfUserQuotesByStateCounters.confirmed > 0))
    );
}
